<template>
  <div class="c-white-background" style="min-height: 100vh;">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <!-- desktop >768px md -->
    <div class="desktop">
      <v-container style="padding: 150px;">
        <div
          class="full-width"
          style=" border-radius: 20px; background-color: #FFF"
        >
          <div style="width: 100%; text-align: center; height: 30px">
            <p
              style="color: #086DAF; font-weight: 600; font-size: 24px; line-height: 65px"
            >
              {{ $t("addPlayer") }}
            </p>
          </div>

          <div v-if="isShow === true" class="flex px-15 mt-20 users-list">
            <div
              v-if="listGolfer.length > 0"
              v-for="(item, index) in listGolfer"
              :key="index"
              class="member mr-10"
            >
              <img
                @error="handleImageError(index)"
                class="imageUser"
                :src="item.avatar || images.DefaultGolfer"
                alt=""
              />
              <img
                class="iconsClose"
                :src="icons.close"
                style="cursor: pointer"
                alt=""
                @click="handleRemoveGolfer(item)"
              />
            </div>
          </div>
          <div v-if="isShow === false" class="flex px-15 mt-20 users-list">
            <div
              v-for="(item, index) in listNameOutSite"
              :key="index"
              class="member mr-10"
            >
              <img
                class="imageUser"
                :src="item.avatar || images.DefaultGolfer"
                alt=""
              />
              <img
                class="iconsClose"
                :src="icons.close"
                style="cursor: pointer"
                alt=""
                @click="handleRemoveOutSite(item)"
              />
            </div>
          </div>
          <div class="column">
            <div
              class="flex justify-content-center full-width type-user-container"
            >
              <button
                @click="choose"
                :class="{ btnIsActive: isActive === 0 }"
                class="btnvID"
              >
                {{ $t("searchByVID") }}
              </button>
              <button
                :class="{ btnIsActive: isActive === 1 }"
                class="btnvID"
                @click="chooseOut"
              >
                {{ $t("outsideSystem") }}
              </button>
            </div>
          </div>
          <div
            v-if="isShow === true"
            style="padding: 10px 40px; min-height: 500px"
          >
            <el-row class="list-extend-account">
              <div class="border-search-bar mb-10">
                <div class="full-width search-bar-container-desktop">
                  <img class="icon-search" :src="icons.SearchIcon" alt="" />
                  <el-input
                    class="input-search-bar"
                    :placeholder="$t('enterNameOrIDToSearch')"
                    v-model="facilityName"
                    @input="handleInput"
                  >
                  </el-input>
                  <img
                    @click="
                      () => {
                        this.facilityName = '';
                      }
                    "
                    class="mr-10"
                    :src="icons.CloseIcon"
                    alt=""
                  />
                </div>
              </div>

              <div v-if="ListSearchGolfer.length > 0">
                <el-checkbox-group
                  v-model="getListGolfer"
                  class="radio-group"
                  style="max-height:440px;  overflow-y: auto;display: grid"
                >
                  <el-checkbox
                    v-for="(item, index) in ListSearchGolfer"
                    :key="index"
                    @change="handleChangeGolfed(item)"
                    :label="item._id"
                    class="radio-check-add-user flex align-items-center mb-10"
                  >
                    <div class="flex align-items-center">
                      <img
                        class="imageUserSearch"
                        :src="item.avatar || icons.Oval2"
                        alt=""
                      />
                      <p class="m-0 c-black-text c-medium-text">
                        {{ item.fullname }}
                      </p>
                    </div>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-row>
          </div>
          <div class="px-15" v-if="isShow === false" style="min-height: 500px">
            <el-row class="list-extend-account">
              <div style="padding: 10px 30px">
                <div class="search-bar-container-out2">
                  <img class="icon-search" :src="icons.member" alt="" />
                  <el-input
                    class="input-search1"
                    :placeholder="$t('enterFullName')"
                    v-model="inputValue"
                    @keyup.enter.native="handleInputConfirm"
                    :icon="icons.Oval2"
                  />
                  <img
                    v-if="inputValue"
                    class="icon-search1"
                    :src="icons.AddIcon"
                    @click="handleInputConfirm"
                    alt=""
                    style="margin-right: 15px; cursor: pointer"
                  />
                </div>
                <div
                  style="max-height:430px;  overflow-y: auto;
              "
                  class="mt-10"
                >
                  <div
                    v-if="listNameOutSite.length > 0"
                    v-for="(item, index) in listNameOutSite"
                    :key="index"
                    class="search-bar-container-out2 mt-20 mb-20"
                  >
                    <img class="icon-search" :src="icons.member" alt="" />
                    <el-input
                      class="input-search1"
                      v-model="item.name"
                      disabled
                      @keyup.enter.native="handleInputConfirm"
                    />
                    <img
                      @click="handleRemoveOutSite(item)"
                      class="icon-search1"
                      :src="icons.RemoveIcon"
                      alt=""
                      style="margin-right: 15px;
                    cursor: pointer"
                    />
                  </div>
                </div>
              </div>
            </el-row>
          </div>
          <div
            style="padding: 20px 40px"
            class="flex justify-content-center"
            @click="handleAddGolfer"
          >
            <el-button
              class="button-add bg-btn-main c-white-text"
              style="height: 55px"
            >
              {{ $t("addPerson") }}
            </el-button>
          </div>
        </div>
      </v-container>
    </div>
    <!-- end of desktop -->
    <!-- mobile <768px xs-->
    <div class="mobile">
      <div class="divider-view-top top-spacing " />
      <div class=" column full-width">
        <div v-if="isShow === true" class="flex px-15 mt-20 users-list">
          <div
            v-if="listGolfer.length > 0"
            v-for="(item, index) in listGolfer"
            :key="index"
            class="member mr-10"
            style="margin-top: 30px"
          >
            <img
              class="imageUser"
              @error="handleImageError(index)"
              :src="item.avatar || images.DefaultGolfer"
              alt=""
            />
            <img
              class="iconsClose"
              :src="icons.close"
              alt=""
              @click="handleRemoveGolfer(item)"
            />
          </div>
        </div>
        <div v-if="isShow === false" class="flex px-15 mt-20 users-list">
          <div
            v-for="(item, index) in listNameOutSite"
            :key="index"
            class="member mr-10"
            style="margin-top: 30px"
          >
            <img
              class="imageUser"
              :src="item.avatar || images.DefaultGolfer"
              alt=""
            />
            <img
              class="iconsClose"
              :src="icons.close"
              alt=""
              @click="handleRemoveOutSite(item)"
            />
          </div>
        </div>
        <div class="column">
          <div
            class="flex justify-content-center full-width type-user-container"
          >
            <button
              @click="choose"
              :class="{ btnIsActive: isActive === 0 }"
              class="btnvID"
            >
              {{ $t("searchByVID") }}
            </button>
            <button
              :class="{ btnIsActive: isActive === 1 }"
              class="btnvID"
              @click="chooseOut"
            >
              {{ $t("outsideSystem") }}
            </button>
          </div>
        </div>
      </div>
      <div class="px-15" v-if="isShow === true">
        <div>
          <el-row class="list-extend-account">
            <div class="border-search-bar mb-10">
              <div class="search-bar-container">
                <img class="icon-search" :src="icons.SearchIcon" alt="" />
                <el-input
                  class="input-search-user"
                  :placeholder="$t('enterNameOrIDToSearch')"
                  v-model="facilityName"
                  @input="handleInput"
                >
                </el-input>
                <img
                  @click="
                    () => {
                      this.facilityName = '';
                    }
                  "
                  class="mr-10"
                  :src="icons.CloseIcon"
                  alt=""
                />
              </div>
            </div>
            <div v-if="ListSearchGolfer.length > 0">
              <el-checkbox-group
                v-model="getListGolfer"
                class="radio-group"
                style="max-height:440px;  overflow-y: auto;display: grid"
              >
                <el-checkbox
                  v-for="(item, index) in ListSearchGolfer"
                  :key="index"
                  @change="handleChangeGolfed(item)"
                  :label="item._id"
                  class="radio-check-add-user flex align-items-center mb-10"
                >
                  <div class="flex align-items-center">
                    <img
                      class="imageUserSearch"
                      @error="handleImageError(index)"
                      :src="item.avatar || icons.Oval2"
                      alt=""
                    />
                    <p class="m-0 c-black-text c-medium-text">
                      {{ item.fullname }}
                    </p>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div v-else>
              <p class="c-black-text mt-20 text-align-center">
                {{ titleEmpty }}
              </p>
            </div>
          </el-row>
        </div>
      </div>
      <div class="px-15" v-if="isShow === false">
        <div>
          <el-row class="list-extend-account">
            <div>
              <div class="search-bar-container-out2">
                <img class="icon-search" :src="icons.member" alt="" />
                <el-input
                  class="input-search1"
                  :placeholder="$t('enterFullName')"
                  v-model="inputValue"
                  :icon="icons.Oval2"
                />
                <img
                  v-if="inputValue"
                  class="icon-search1"
                  :src="icons.AddIcon"
                  alt=""
                  style="margin-right: 15px"
                  @click="handleInputConfirm"
                />
              </div>
              <div
                style="max-height:430px;  overflow-y: auto;
              "
                class="mt-10"
              >
                <div
                  v-if="listNameOutSite.length > 0"
                  v-for="(item, index) in listNameOutSite"
                  :key="index"
                  class="search-bar-container-out2 mt-20 mb-20"
                >
                  <img class="icon-search" :src="icons.member" alt="" />
                  <el-input
                    class="input-search1"
                    v-model="item.name"
                    disabled
                    @keyup.enter.native="handleInputConfirm"
                  />
                  <img
                    @click="handleRemoveOutSite(item)"
                    class="icon-search1"
                    :src="icons.RemoveIcon"
                    alt=""
                    style="margin-right: 15px"
                  />
                </div>
              </div>
            </div>
          </el-row>
        </div>
      </div>
      <div
        style="position:fixed;bottom:22px "
        class="flex justify-content-center w-100 px-15"
      >
        <ButtonCustomer
          :styles="{
            fontSize: '14px',
            fontWeight: 600,
            height: '40px',
            borderRadius: '8px',
            background: 'linear-gradient(90deg, #025991 0%, #0971B5 100%)'
          }"
          :object-data="{ title: $t('addPerson') }"
          @on-action="handleAddGolfer"
        />
        <!-- <el-button class="button-add bg-btn-main c-white-text ">
          {{ $t("addPerson") }}
        </el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getBackGround } from "@/utils/wapAuth";
import GlobalAPI from "@/views/api/wap/global";
import SearchIcon from "@/assets/img/svg/searchIcon.svg";
import Oval from "@/assets/img/svg/Oval.svg";
import Oval2 from "@/assets/img/svg/Oval2.svg";
import close from "@/assets/img/svg/close.svg";
import member from "@/assets/img/svg/member.svg";
import AddIcon from "@/assets/img/svg/addIcon.svg";
import RemoveIcon from "@/assets/img/svg/removeIcon.svg";
import DefaultGolfer from "@/assets/img/DefaultGolfer.png";
import warning from "@/assets/img/svg/warning.svg";
import MainNavBarWapV2 from "../../../../layout/WapV2/MainNavBar.vue";
import CloseIcon from "@/assets/img/svg/close-icon.svg";
import TeeTimeResource from "@/views/api/wap/detail-tee-time";
import { mergeArraysByCommonKey } from "@/utils/formatData";
import { debounce } from "lodash";
import { decodeToken } from "@/utils/auth";
import { getToken, getInfo } from "@/utils/wapAuth";
import { mapGetters } from "vuex";
import ButtonCustomer from "@/components/wapV2/button/index.vue";

export default {
  components: {
    MainNavBarWapV2,
    ButtonCustomer
  },
  bodyClass: "add-member",
  props: {},
  computed: {
    ...mapGetters(["list_golfer_booking"]),
    getListGolfer: {
      get() {
        return this.listGolfer.map(item => item.vga) || [];
      },
      set(value) {}
    }
  },
  created() {
    if (!getInfo()) {
      this.$store.dispatch("showLoginDialog");
      return;
    }
    console.log(
      "this.list_golfer_booking.list_golfer))))))",
      this.list_golfer_booking.list_golfer
    );

    if (this.list_golfer_booking.list_golfer) {
      this.listGolfer = this.list_golfer_booking.list_golfer.filter(
        item => +item.vga > 0
      );
      this.handleInfoHeader(this.listGolfer.length);
      this.listNameOutSite = this.list_golfer_booking.list_golfer.filter(
        item => +item.vga < 0
      );
    }
    // if (
    //   this.$store.getters.list_golfer_booking.tee_id ===
    //   this.$route.query?.tee_id
    // ) {
    //   this.listGolfer = this.$store.getters.list_golfer_booking.list_golfer.filter(
    //     item => +item.vga > 0
    //   );
    //   this.listNameOutSite = this.$store.getters.list_golfer_booking.list_golfer.filter(
    //     item => +item.vga < 0
    //   );
    //   this.teeTime_money = this.$store.getters.list_golfer_booking.money;
    // }
  },
  data() {
    return {
      tab: "",
      titleEmpty: "",
      ListSearchGolfer: [],
      loadingSearchGolfer: false,
      inputValue: "",
      infoHeader: {
        title: this.$t("addPlayer"),
        otherTitle: `${this.$t("listUser")}: ${
          this.$store.getters.list_golfer_booking.list_golfer.length
        }`,
        isShowHomeIcon: false
      },
      isShow: true,
      activeName: "1",
      isInsideWGHN: 1,
      bg: getBackGround(),
      isActive: 0,
      query: {},
      listNameOutSite: [],
      listGolfer: [],
      icons: {
        SearchIcon,
        Oval,
        close,
        Oval2,
        member,
        warning,
        CloseIcon,
        RemoveIcon,
        AddIcon
      },
      images: {
        DefaultGolfer
      },
      facilityName: "",
      teeTime_money: 0
    };
  },
  watch: {},
  methods: {
    handleImageError(index) {
      // Xử lý khi đường dẫn ảnh không hợp lệ
      // Thay thế đường dẫn ảnh bằng đường dẫn hình ảnh mặc định
      this.ListSearchGolfer[index].avatar = this.images.DefaultGolfer;
    },
    handleChangeGolfed(val) {
      if (!val) return;
      // if (val._id === getToken().vga) {
      //   this.$message.warning("Không thể xóa chủ tài khoản.");
      //   return;
      // }
      const exits = this.listGolfer.filter(item => item.vga == val._id);
      // console.log("exits", exits);
      if (exits && exits.length > 0) {
        this.listGolfer.splice(this.listGolfer.indexOf(exits[0]), 1);
        return;
      }
      let golfer = {
        id: val._id,
        vga: val._id,
        name: val.fullname,
        money: +this.teeTime_money,
        avatar: val.avatar,
        checked: true,
        hio_list: []
      };
      this.listGolfer.push(golfer);
      this.handleInfoHeader(this.listGolfer.length);
    },
    debouncedSearchGolfers: debounce(async function(keyword) {
      this.loadingSearchGolfer = true;

      TeeTimeResource.searchGolfer(
        {
          q: keyword,
          page: 1,
          number: 7,
          lang: "en"
        },
        {
          q: keyword,
          page: 1,
          number: 7,
          lang: "en"
        }
      )
        .then(response => {
          const dataChecked = this.ListSearchGolfer.filter(item =>
            this.getListGolfer.includes(item?._id)
          );
          const vgaId = parseInt(decodeToken().vga);
          this.ListSearchGolfer = [...response.data, ...dataChecked].filter(
            (obj, index, self) => {
              // Kiểm tra xem _id của đối tượng có trùng với vgaId không
              const isNotDuplicate = obj._id !== vgaId;
              // Kiểm tra xem đối tượng hiện tại là duy nhất trong mảng hay không
              const isUnique = index === self.findIndex(o => o._id === obj._id);
              // Trả về true nếu đối tượng không trùng với vgaId và là duy nhất
              return isNotDuplicate && isUnique;
            }
          );

          if (this.ListSearchGolfer.length < 1)
            this.titleEmpty = this.$t("playerNotFound");
          else this.titleEmpty = "";
        })
        .finally(() => {
          this.loadingSearchGolfer = false;
        });
    }, 300),

    // Xử lý sự kiện khi người dùng nhập
    handleInput(keyword) {
      this.debouncedSearchGolfers(keyword); // Gọi hàm debouncedSearchGolfers để gọi API sau khi người dùng dừng nhập trong 2 giây
    },
    handleRemoveOutSite(val) {
      this.listNameOutSite.splice(this.listNameOutSite.indexOf(val), 1);
      this.handleInfoHeader(this.listNameOutSite.length);
    },
    handleRemoveGolfer(val) {
      // console.log("val___________", val);
      if (!val) return;
      // if (val.id == getToken().vga) {
      //   this.$message.warning("Không thể xóa chủ tài khoản.");
      //   return;
      // }
      this.listGolfer.splice(this.listGolfer.indexOf(val), 1);
      this.handleInfoHeader(this.listGolfer.length);
      this.ListSearchGolfer = this.ListSearchGolfer.map(item => item);
    },
    handleInfoHeader(length) {
      this.infoHeader = {
        title: this.$t("addPlayer"),
        otherTitle: `${this.$t("listUser")}: ${length}`,
        isShowHomeIcon: false
      };
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        let golfer = {
          id: -1,
          vga: -1,
          name: inputValue,
          // hio_100: false,
          // hio_200: false,
          money: +this.teeTime_money,
          avatar: "",
          hio_list: []
        };
        this.listNameOutSite.push(golfer);
        this.handleInfoHeader(this.listNameOutSite.length);
      }
      this.inputValue = "";
    },
    async remoteMethod(keyword, cb) {
      if (keyword === "" || keyword === undefined) {
        cb([]);
        return;
      }
      const { data, error_code } = await GlobalAPI.searchFacility({
        q: keyword.trim()
      });
      if (error_code === 0) cb(data.facilities);
      else cb([]);
    },
    handleSelect(item) {
      this.facilityName = item.sub_title;
      this.facilityID = item.id;
    },
    handleAddGolfer() {
      this.$store.dispatch("update_list_golfer_booking", {
        ...this.list_golfer_booking,
        list_golfer: [...this.listGolfer, ...this.listNameOutSite]
      });
      this.$router.go(-1);
    },
    handleClear() {
      this.facilityName = "";
      this.facilityID = "";
    },
    handleClose() {},
    navigateHotDeals() {
      this.$router.push("/wap/hot-deal");
    },
    choose() {
      this.isActive = 0;
      this.isShow = true;
      this.handleInfoHeader(this.listGolfer.length);
    },
    chooseOut() {
      this.isActive = 1;
      this.isShow = false;
      this.handleInfoHeader(this.listNameOutSite.length);
    },
    mergeArraysByCommonKey
  }
};
</script>
<style>
.input-search-user input {
  height: 40px !important;
  width: 100%;
  color: #000;
  border: none;
  border-radius: 100px;
  padding: 0 0 0 14px;
}
.radio-check-add-user .el-checkbox__input.is-checked .el-checkbox__inner {
  width: 22px !important;
  height: 22px !important;
  background: v-bind("bg.c_button_main") !important;
  border: 2px solid v-bind("bg.c_button_main") !important;
}
.radio-check-add-user .el-checkbox__input .el-checkbox__inner {
  width: 22px !important;
  height: 22px !important;
  border: 2px solid #bfbfc2;
  border-radius: 22px;
}
.radio-check-add-user .el-checkbox__input .el-checkbox__inner::after {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  content: "";
  border: 1px solid;
  border-color: #ffffff !important;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 7px;
  position: absolute;
  top: 4px;
  -webkit-transform: rotate(45deg) scaleY(0);
  transform: rotate(45deg) scaleY(0);
  width: 3px;
  -webkit-transition: -webkit-transform 0.15s ease-in 0.05s;
  transition: -webkit-transform 0.15s ease-in 0.05s;
  transition: transform 0.15s ease-in 0.05s;
  transition: transform 0.15s ease-in 0.05s,
    -webkit-transform 0.15s ease-in 0.05s;
  transition: transform 0.15s ease-in 0.05s,
    -webkit-transform 0.15s ease-in 0.05s;
  -webkit-transform-origin: center;
  transform-origin: center;
}
.input-search1 input {
  color: #000;
  height: 50px;
  border: none;
  background: #ffffff !important;
  padding: 0 0 0 14px;
  width: 100%;
}
</style>

<style lang="scss" scoped>
.users-list {
  overflow-x: auto;
  padding-bottom: 15px !important;
}
.imageUserSearch {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  margin-right: 10px;
}
.imageUser {
  border-radius: 50%;
  box-shadow: 0px 0px 4px 0px #00000040;
  width: 54px;
  height: 54px;
  border: 1px solid #ffff;
  object-fit: cover;
}
.iconsClose {
  position: absolute;
  z-index: 1000;
  right: -5px;
}
.mt-20 {
  margin-top: 20px;
}
.px-15 {
  padding: 0 15px;
}
.type-user-container {
  border: 0.5px solid #707070;
  border-left: none;
  border-right: none;
}
.btnIsActive {
  border: none;
  width: 100%;
  color: v-bind("bg.c_text_main") !important;
  font-weight: 600;
  border-bottom: 2px solid v-bind("bg.c_border") !important;
}
.btnvID {
  min-height: 44px;
  color: #999999;
  border: none;
  width: 100%;
  font-size: 14px;
}

.text {
  color: #090710;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.button-add {
  width: 100%;
  height: 40px;
  border-radius: 8px;
}
.radio-group {
  padding: 15px 0 0 0;
}

.icon-search {
  color: #999999;
  margin-left: 12px;
}
.mb-20 {
  margin-bottom: 20px;
}
.tab-all {
  display: flex;
  justify-content: center;
}

.list-extend-account {
  padding-top: 15px;
  width: 100%;
}

.member {
  position: relative;
  flex-shrink: 0;
}

.border-search-bar {
  display: flex;
  justify-content: center;
}
.search-bar-container-out {
  background: #ffffff;
  border-radius: 50px;
  display: flex;
  align-items: center;
  width: 374px;
  height: 40px;
}
.search-bar-container-out2 {
  max-height: 200px;
  overflow: auto;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
.search-bar-container {
  background: v-bind("bg.c_background1");
  border-radius: 50px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
}
.search-bar-container-desktop {
  background: #dee0e2;
  border-radius: 100px;
  height: 50px;
  display: flex;
  align-items: center;
}

.full-width {
  width: 100%;
}

.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}

.desktop {
  display: block;
}

.mobile {
  display: none;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .title-h3 {
    font-size: 14px !important;
  }
  .time-container {
    display: flex;
    align-items: center;
    margin: 0 5px !important;
  }
  .text-time {
    font-size: 13px;
  }

  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .top-spacing {
    padding-top: 20px;
  }
}
</style>
